import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D2F19A25-4EF4-41A7-A91A-C03C77E32186
 * name skip-next
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-next.svg
 * tags
 * - Home Automation 
 */
export const SkipNextIcon = createSvgIcon(<><path d="M16,18H18V6H16M6,18L14.5,12L6,6V18Z" /></>, 'SkipNextIcon');
export default SkipNextIcon